import React from 'react';

import { FeatureCategories } from 'src/modules/designStudio/constants';
import { MenuItems } from 'src/modules/designStudio/constants/hardCodedData/textureData';
import { getRenderSelectorsForFilters } from 'src/modules/designStudio/helpers/filters';
import { DesignConfig } from 'src/modules/designStudio/types';

import { UpdateDesignFunction } from '../../../providers/HistoryProvider';
import { ColorList } from '../Filters/ColorList';
import { TextureList } from '../Filters/TextureList';
import { TypeFilter } from '../Filters/TypeFilter';

export const RoofMenu = ({
  designConfig,
  updateDesign,
}: {
  designConfig: DesignConfig;
  updateDesign: UpdateDesignFunction;
}) => {
  const { textureId, color } = designConfig[FeatureCategories.ROOF] as {
    textureId: number | null;
    color: string | null;
  };

  const selectedMenuItem = MenuItems.find(item => item.textureId === textureId);
  const {
    shouldRenderColorList,
    shouldRenderTextureList,
  } = getRenderSelectorsForFilters(selectedMenuItem);

  return (
    <>
      <TypeFilter
        designConfigCategory={FeatureCategories.ROOF}
        previousColor={color}
        selectedMenuItem={selectedMenuItem}
        updateDesign={updateDesign}
      />
      {shouldRenderColorList ? (
        <ColorList
          color={color}
          designConfig={designConfig}
          designConfigCategory={FeatureCategories.ROOF}
          updateDesign={updateDesign}
        />
      ) : null}
      {shouldRenderTextureList ? (
        <TextureList
          designConfigCategory={FeatureCategories.ROOF}
          selectedMenuItem={selectedMenuItem}
          updateDesign={updateDesign}
        />
      ) : null}
    </>
  );
};
